import { useEffect, useState } from "react";
import api from "../lib/api";
import { displayName } from "../lib/anagConfig";
import { Building2 } from "lucide-react";
import PraticaSummaryChips from "./PraticaSummaryChips";
import CompagniaDettaglioDialog from "./CompagniaDettaglioDialog";

const norm = (s) => (s || "").trim().toLowerCase().replace(/\s+/g, " ");

// Mostra il nome della compagnia (scheda pratica), un pulsante per aprire la scheda anagrafica
// della compagnia e, sotto, i recapiti configurati (secondo le preferenze della compagnia).
export default function CompagniaPraticaInfo({ compagnia, testId }) {
  const [comps, setComps] = useState(null);
  const [open, setOpen] = useState(false);

  useEffect(() => { api.get("/anagrafiche/compagnie").then(({ data }) => setComps(data || [])).catch(() => setComps([])); }, []);

  if (!compagnia) return <span className="text-slate-400">—</span>;
  const rec = (comps || []).find((c) => [displayName(c), c.denominazione, c.ragione_sociale, c.nome, c.compagnia].some((x) => norm(x) === norm(compagnia)));

  return (
    <div className="w-full" data-testid={testId}>
      <div className="flex items-center gap-2">
        <span className="font-semibold text-slate-900 break-words">{compagnia}</span>
        {rec && (
          <button type="button" onClick={() => setOpen(true)} data-testid={testId ? `${testId}-open` : undefined}
            title="Apri scheda compagnia" className="text-slate-500 hover:text-amber-600 transition-colors shrink-0">
            <Building2 className="h-4 w-4" />
          </button>
        )}
      </div>
      {rec && <PraticaSummaryChips rec={rec} testId={testId} waCategory="compagnia" />}
      {rec && open && (
        <CompagniaDettaglioDialog open={open} onOpenChange={setOpen} rec={rec} defaultTab="ispettorati"
          onSaved={(doc) => { if (doc && doc.id) setComps((prev) => (prev || []).map((c) => (c.id === doc.id ? doc : c))); }} />
      )}
    </div>
  );
}
